// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".condition-options{background-color:#ebebeb;border-radius:5px;min-height:40px;display:flex;align-items:center;border-style:dashed;border-width:1px}", ""]);
// Exports
module.exports = exports;
